import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./Feedback.css";
import Overlay from "../../components/Overlay";
import { Modal } from "../../components/Modal";
import { extractDate, extractOnlyDate, subadminAccessChange } from "../../utils/functions";
import * as XLSX from 'sheetjs-style';
import { saveAs } from "file-saver";
import ReactReadMoreReadLess from "react-read-more-read-less";

// Mui & material UI
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import SearchBar from "material-ui-search-bar";
import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Popover, Box } from "@mui/material";
import PaginationItem from '@mui/material/PaginationItem';

import {
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination
} from "@material-ui/core";

// icons 
import { HiOutlineBars3BottomLeft } from "react-icons/hi2";
import { RxCross2, RxCrossCircled } from "react-icons/rx";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { AiOutlineDownload } from "react-icons/ai";
import { FiPlusCircle } from "react-icons/fi";
import { LuPencilLine } from "react-icons/lu";
import { FiEye } from "react-icons/fi";

import EyeIcon from "../../assets/images/eye-tick.png";
import UserIcon from "../../assets/images/users-check.png";
import Star from "../../assets/images/star.png";

// Elements

import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    SearchFilterContainer,
    DashHeading,
    Button,
    DeleteButton,
    ProfileDetailForm,
    SelectedColumnContainer,
} from "./FeedbackElement";
import zIndex from "@material-ui/core/styles/zIndex";
import NoResults from "../../components/NoResult";
import Loading from "../../components/Loading";


const useStyles = makeStyles((theme) => ({
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px', // adds vertical spacing between rows
    },
    tableMainContainer: {
        maxHeight: "65vh",
        overflowX: "auto",
        overflowY: "auto",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
    },
    tableHeadingRow: {
        position: "sticky", // Make header sticky
        top: 0, // Stick to the top
        zIndex: 1, // Ensure it appears above other rows
        background: "#FFFFFF", // Header background color
        border: "1px solid rgba(17, 153, 38, 0.20)",

    },
    tableBodyRow: {
        background: "#FFFFFF",
        // border: "1px solid rgba(17, 153, 38, 0.20)",

        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    tableHeadingCell: {
        // padding: "0.5rem 1rem !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#1C2D28",
        fontWeight: "500",
        // border: "1px solid #D9E3D9",
        whiteSpace: "nowrap",
        background: "#FFFFFF",
        border: "none"
    },
    textMiddle: {
        // padding: "0.4rem 1rem !important",
        verticalAlign: "middle !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#484848",
        fontFamily: "Roboto",
        fontWeight: "400",
        background: "#FFFFFF",
        border: "none"
    },
    tablePaginationStyle: {
        borderTop: "1px solid #0000001a",
        borderRadius: "0rem 0rem 0.4rem 0.4rem",
        overflowY: "hidden",
    },
    paginationContainer: {
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));


const FeedbackManagement = ({ setUsers, userData }) => {
    const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

    const feedbackManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "Feedback Management"
    )?.permissions || {};


    const canView = !!feedbackManagementPermissions.view;
    const canAdd = !!feedbackManagementPermissions.add;
    const canEdit = !!feedbackManagementPermissions.edit;
    const canDelete = !!feedbackManagementPermissions.delete;
    const canBlockUnblock = !!feedbackManagementPermissions.blockUnblock;
    const canDownload = !!feedbackManagementPermissions.download;

    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [excelData, setExcelData] = useState([]);


    const [deleteModal, setDeleteModal] = useState(false);
    const [filterStatus, setFilterStatus] = useState("all");



    // For Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocs, setTotalDocs] = useState(0);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(1); // Reset to the first page when rows per page change
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Update page and trigger data fetch
    };


    // For Select checkbox
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        if (tableData.length === 0) {
            setSelectedRows([]);
        }
    }, [tableData]);

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedRows(tableData.map((item) => item._id));
        } else {
            setSelectedRows([]);
        }
    };

    const handleSelectRow = (id) => {
        const newSelectedRows = selectedRows.includes(id)
            ? selectedRows.filter((rowId) => rowId !== id)
            : [...selectedRows, id];
        setSelectedRows(newSelectedRows);
    };

    const handleClearSelection = () => {
        setSelectedRows([]);
    };

    const [anchorEl, setAnchorEl] = useState(null);



    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget); // Open the filter popover
    };

    const handleClose = () => {
        setAnchorEl(null); // Only close the popover without resetting
    };



    const open = Boolean(anchorEl);
    const id = open ? "filter-popover" : undefined;

    // For Search functionality
    const [searchTerm, setSearchTerm] = useState("");

    function myDeb(call, d = 1000) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                call(...args);
            }, d);
        };
    }

    const SearchAccountManagement = myDeb((search) => {
        setSelectedRows([]);
        setSearchTerm(search);
        setPage(1); // Reset to the first page on search
    });

    const cancelSearch = () => {
        setSearchTerm("");
        setPage(1); // Reset to the first page when search is canceled
    };



    // Get user data
    useEffect(() => {
        getFeedbackManagement(page)
        getExcelData()
            .then((res) => res.json())
            .then((data) => setExcelData(data))
            .catch((error) => console.error("Error fetching data:", error));

    }, [page, rowsPerPage, searchTerm, filterStatus]);

    const getFeedbackManagement = async (currentPage) => {
        setIsLoading(true);
        setTotalDocs(0);

        try {
            const { data } = await axios.get(`/private/getAppFeedbackList?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`, {
                status: String(filterStatus), // Ensure status is a string
            });

            setTableData(data?.data?.docs);
            setTotalDocs(data?.data?.totalDocs);
        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };



    const handleDownload = () => {
        // Format keys: convert camelCase to space-separated & capitalize, handle _id
        const formatKey = (key) => {
            if (key === '_id') return 'User Id';
            return key
                .replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space before capital letters
                .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
        };

        const formatValue = (key, value) => {
            if ((key === "createdAt") && value) {
                return new Date(value).toLocaleString("en-US", {
                    month: "2-digit",
                    day: "2-digit",
                    year: "numeric",

                });
            }
            return value;
        };


        // Format data with formatted headers
        const formattedData = excelData.map(item => {
            const newItem = {};
            Object.entries(item).forEach(([key, value]) => {
                newItem[formatKey(key)] = formatValue(key, value);
            });
            return newItem;
        });


        // Create worksheet from formatted data
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Auto-calculate column widths
        const keys = Object.keys(formattedData[0] || {});
        const colWidths = keys.map(key => {
            const maxLength = Math.max(
                key.length,
                ...formattedData.map(row => (row[key] ? row[key].toString().length : 0))
            );
            return { wch: maxLength + 2 };
        });
        worksheet["!cols"] = colWidths;

        // Bold header row (row 0)
        keys.forEach((key, index) => {
            const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = {
                    font: { bold: true }
                };
            }
        });

        // Create workbook and append sheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Write and download
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, "table_data.xlsx");
    };




    const getExcelData = async () => {

        try {
            const { data } = await axios.get(`/private//appFeedback/getExcelDataList`);
            setExcelData(data?.data);


        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <DashboardContainer>
                <DashboardWrapper>
                    <ProfileDetailForm>
                        <DashboardHeading>
                            Feedback Management
                        </DashboardHeading>

                        <SearchFilterContainer>
                            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                <SearchBar
                                    style={{
                                        minWidth: "25rem",
                                        height: "38px",
                                        borderRadius: "20px",
                                        backgroundColor: "#F8F9FB",
                                        color: "#212121",
                                        fontStyle: "Italic",
                                        fontWeight: 300,
                                        fontSize: "15px",
                                        fontFamily: "Roboto",
                                    }}
                                    className={"heightfix"}
                                    onChange={(e) => {
                                        SearchAccountManagement(e);
                                    }}
                                    onCancelSearch={cancelSearch}
                                    placeholder="Search Username..."
                                    inputProps={{ maxLength: 30 }}
                                />
                            </div>
                            <div style={{ display: "flex", gap: "1rem" }}>
                                {!(!canDownload && adminData?.userType === "subAdmin") && (
                                    <Button
                                        type="button"
                                        style={{ backgroundColor: "#5088FB", color: "#FFFFFF", border: "1px solid #5088FB", fontSize: "14px", padding: "6px 8px" }}

                                    >
                                        <div onClick={handleDownload}>Export as xlsx <AiOutlineDownload style={{ fontSize: "1.3rem" }} /></div>
                                    </Button>
                                )}

                            </div>
                        </SearchFilterContainer>


                        {selectedRows.length > 0 && (
                            <SelectedColumnContainer>
                                <DeleteButton
                                    type="button"
                                    className="buttonWidthResponsive"
                                    onClick={() => {
                                        setDeleteModal(true);
                                    }}
                                >
                                    Delete
                                </DeleteButton>
                                <div className="column-selected">{selectedRows.length} Selected</div>
                                <div
                                    className="container-clear-selection"
                                    onClick={handleClearSelection}
                                >
                                    <RxCrossCircled />
                                    <span className="column-selected">Clear Response</span>
                                </div>
                            </SelectedColumnContainer>
                        )}

                        <TableContainer
                            className={classes.tableMainContainer}
                        >
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.tableHeadingRow}>
                                        <TableCell className={classes.tableHeadingCell}>
                                            S.No
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Created at
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                User Name
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Experience Rate
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Recommend Freelancer
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                Review
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                Improvement Suggestion
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                Future Versions Suggestion
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {tableData && tableData.length > 0 ? (
                                    <>
                                        <TableBody>
                                            {tableData.map((user, index, block) => (
                                                <TableRow className={classes.tableBodyRow} key={user._id}>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{extractOnlyDate(get(user, "createdAt", "---"))}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{
                                                            color: "#5088FB",
                                                            cursor: "pointer",
                                                            textAlign: "left",
                                                            marginLeft: "2rem"
                                                        }}
                                                            onClick={() => navigate(`/userDetails/${user.userId}`,
                                                                { state: { from: "feedbackManagement" } })}
                                                        >
                                                            {get(user, "userName", "---")}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}>
                                                            <div style={{
                                                                background: "#FFF4E7",
                                                                border: "0.75px solid #0000001F",
                                                                height: "1.5rem",
                                                                width: "3rem",
                                                                fontSize: "14px",
                                                                color: "#212121",
                                                                fontStyle: "bold",
                                                                fontWeight: "700",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: "1px"
                                                            }}>

                                                                <span>{get(user, "rating", "---")}</span> <span><img src={Star} style={{ height: "11px", marginBottom: "2.5px" }} /></span>

                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        {
                                                            get(user, "recommendToFreelancer") === true
                                                                ? "Yes"
                                                                : get(user, "recommendToFreelancer") === false
                                                                    ? "No"
                                                                    : "N/A"
                                                        }
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                            <ReactReadMoreReadLess
                                                                charLimit={10}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                                readMoreStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                                                readLessStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                                            >
                                                                {user?.reviewMsg || "N/A"}
                                                            </ReactReadMoreReadLess>
                                                            {/* {get(user, "reviewMsg", "---")} */}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                            <ReactReadMoreReadLess
                                                                charLimit={10}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                                readMoreStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                                                readLessStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                                            >
                                                                {user?.whatCanBeImproved || "N/A"}
                                                            </ReactReadMoreReadLess>

                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                            <ReactReadMoreReadLess
                                                                charLimit={10}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                                readMoreStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                                                readLessStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                                            >
                                                                {user?.futureFeatureSuggestions || "N/A"}
                                                            </ReactReadMoreReadLess>
                                                            {/* {get(user, "futureFeatureSuggestions", "---")} */}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </>
                                ) : (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={13} align="center" style={{ padding: "2rem", border: "none" }}>
                                                    <DashHeading style={{ textAlign: "center", padding: "2rem" }}><NoResults /></DashHeading>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {(tableData && tableData.length > 0) && (
                            <>
                                <Stack spacing={2} className={classes.paginationContainer}>
                                    <Pagination
                                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                                        page={page}
                                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                                        renderItem={(item) => (
                                            <PaginationItem
                                                slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                                                {...item}
                                            />
                                        )}
                                    />
                                </Stack>
                            </>
                        )}
                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer>



            {isLoading && <Overlay />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FeedbackManagement);





